module.exports = __webpack_public_path__ + "img/6.e36ba02b.jpg";